import React from 'react';
import styled from 'styled-components';

const Label = styled.span`
  display: inline-block;
  font-size: ${(p) => (p.$large ? '1rem' : '0.85rem')};
  font-weight: 800;
  letter-spacing: 0.28em;
  text-indent: 0.28em;
  text-transform: uppercase;
  vertical-align: middle;
  background: linear-gradient(135deg, #fffef0 0%, #fff3a8 35%, #ffee66 70%, #ffe9a8 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  filter: drop-shadow(0 0 10px rgba(255, 238, 100, 0.55));
`;

function BetaLabel({ large = false }) {
  return (
    <Label $large={large} aria-label="Beta version">
      Beta
    </Label>
  );
}

export default BetaLabel;
